<template>
	<div class="rank_bg">
  
 <!--  <h1 style="text-align: center;font-size: 2em;font-weight: bold;margin-top: 8vh;color: #fff;">排行榜</h1> -->
		<!-- <van-image width="100" height="100" :src="user.avatar" /> -->
		<ul>
			
			      <li v-for="(item, index) in list">
            <span style="color: #fff">{{index+1}}</span>

			      <van-image width="50" height="50" :src="item.avatar" round style="margin-top:5px;"/>
            <p style="color:#fff;text-align: center;margin-left: 10px;width: 100px;float: left;">{{item.name}}</p>
			      <p style="color: #fff">最高得分：{{item.max_point}}分<br>最短耗时：{{item.min_user_time}}秒</p>
			      </li>
         <!--  <van-divider  :style="{ color: '#1989fa' ,padding: '0' ,margin:'0',width:'88vw'}"/>   -->    
        </ul>
	</div>
</template>
<script>
import { getRank } from '@/api/user'
export default {
    data() {
        return {
            info: this.$store.state.acc,
            user: this.$store.state.user,
            list: [],
        }
    },
    created(e) {
    	this.getList()
    },
    methods: {
    	getList (){
    		this.$toast.loading({
		      message: '加载中...',
		      forbidClick: false,
		      loadingType: 'spinner',
		      duration: 10000
		    });
    		getRank({limit:20}).then(res=> {
    			this.$toast.clear()
                this.list = res.data
    		})
    	}
    }
}
</script>
<style scoped>
.rank_bg{
  background: url(http://oss.ahxmgk.com/yun/uploads/image/2022/01/07/78994e49cb3191ee34267bfcef9a5e91.jpg) no-repeat center;
  background-size: 100% 100%;
  width: 100vw;
  /* height: 100vh; */
  padding-bottom: 20px;
  min-height: 100vh;
  background-attachment: fixed;
  /*overflow: hidden;*/
  font-size: 1.0em;
  overflow: hidden;
}
li>.van-image{
	float: left;
	width: 17vw;
	height: 17vw;
	border-radius: 50%;
}
.rank_tit{
  background: rgba(255,255,255,1);
  min-height: 100%;
  margin-top: -0.3em;
  /*margin: 8vh 8vw;*/
}
ul{
  text-align: left;
  margin:  0 1vh;
  font-size: 1.1em;
  
  width: 90%;
  margin: 0 auto;
  margin-top: 15vh;
  padding: 3vh 2vw;
  background: rgba(255, 255, 255, 0.3);

}
ul li {
  
  width: 100%;
  overflow: hidden;
  
  color: #0570DB;
	padding-bottom: 2px;
  border-bottom: 1px #d5d5d5 solid;
  /* height: 8vh; */
}
ul h3{
  width: 30vw;
  font-weight: normal;
  float: left;
  margin: 0.2em;
  line-height: 7vh;
  text-align: center;
}
ul p{
  width: 35vw;
  float: right;
  font-size: 1em;
  line-height: 1.3em;
  margin-top: 13px;
 
}

ul span{
  float: left;
  line-height: 7vh;
  margin: 10px 3vw 0 0;
	font-size: 1.5em;
  text-align: center;
  color: #000;
  font-weight: bold;
}
ul li:first-child span{
  float: left;
  /* font-size: 2em; */
  /* color: #dfaf27; */
}
ul li:nth-of-type(2) span{
  float: left;
  /* font-size: 1.7em; */
  /* color: #c2c2c2; */
}
ul li:nth-of-type(3) span{
  float: left;
  /* font-size: 1.4em; */
  /* color: #c47c30; */
}

</style>
